import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'spaceText'})
export class SpaceTextPipe implements PipeTransform {
  transform(value: string): any {
    if (value == 'heyLounge') return 'Hey Lounge+';
    if (value == 'skyLounge') return 'Sky Lounge';
    if (value == 'terrace') return 'Sky Lounge + Terrace';
    return '';
  }
}


// WEBPACK FOOTER //
// ./src/app/pipe/space-text.pipe.ts